import { render, staticRenderFns } from "./create-notes.vue?vue&type=template&id=643212b3"
import script from "./create-notes.vue?vue&type=script&lang=js"
export * from "./create-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports